// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3rb0z","inner":"Footer_inner__1nfsR","nextIcon":"Footer_nextIcon__2uzsJ","innerLeft":"Footer_innerLeft__2hntJ"};